export default "__VITE_ASSET__gYZTAwdo__"